import { useWSAnalytics } from "../../../utils/WSAnalytics";
import pick from "lodash/pick";
import { WSNotificationResponse } from "../components/Notifications";

export const useTrackClickNotification = (personId: string) => {
  const { track } = useWSAnalytics();

  return (notification: WSNotificationResponse) => {
    track.other("Notification Clicked", {
      personId,
      ...pick(
        notification,
        "id",
        "type",
        "context",
        "priority",
        "handle",
        "subject"
      )
    });
  };
};
